import { CoordinatesModel, SelectedLocation } from '@core';

export const hasValidAlertCoordinates = (
  coordinates: CoordinatesModel | null | undefined
): coordinates is CoordinatesModel => {
  if (!coordinates) return false;

  const { latitude, longitude } = coordinates;

  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return false;

  return latitude !== 0 || longitude !== 0;
};

export const sanitizeAlertLocation = (location: SelectedLocation | null): SelectedLocation | null =>
  hasValidAlertCoordinates(location?.coordinates) ? location : null;
